import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Button from './ButtonLoader';
import { accessToken, env } from '../utils/AuthManager';
import { getSignedUrl, initiateDownload } from '../services/aws';

class ButtonS3Downloader extends Component {
    state = {
        downloading: false
    }
    onClick = () => {
        this.setState({ downloading: true })
        initiateDownload(accessToken, env, this.props.file).then(response => {
            getSignedUrl(accessToken, env, response.filename).then(response => {
                this.setState({ downloading: false })
                if (response.preSignedUrl) {
                    this.downloadURI(response.preSignedUrl)
                }
            }).catch(error => {
                this.setState({ downloading: false })
            })
        }).catch(error => {
            this.setState({ downloading: false })
        })
    }
    downloadURI(uri) {
        var link = document.createElement('a');
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    onSignedUrl = (result) => {
        try {
            if (result) {
                var url = result.signedUrl;
                console.log('Downloading file: ', url);
                this.downloadURI(url);
            }
        }
        finally {
            this.setState({
                downloading: false
            });
        }
    }

    render() {
        const {
            children,
            getSignedUrl,
            ...other
        } = this.props;

        return (
            <Button {...other} loading={this.state.downloading} onClick={this.onClick}>{children}</Button>
        );
    }
}

ButtonS3Downloader.propTypes = {
    children: PropTypes.node,
    getSignedUrl: PropTypes.func.isRequired
};

ButtonS3Downloader.defaultProps = {
    children: null
};

export default ButtonS3Downloader;